import { ExpLobbyFocusOnWelcomeAndReg } from './helpers';
import { abTestingFunction } from '@/helpers/abTesting';
import { useCommonStore, useModalsStore } from '@/store';

export const useIsLobbyFocusOnWelcomeAndRegABTest = () => {
  const modal = useModalsStore.use.modal();
  const isMobileDevice = useCommonStore.use.isMobileDevice();
  const cmsABTests = useCommonStore.use.cmsABTests();

  if (modal || !isMobileDevice) return false;

  return (
    abTestingFunction(
      'exp_lu_lobby_focus_on_welcome_and_reg',
      {
        defaultVersion: ExpLobbyFocusOnWelcomeAndReg.A,
        versions: [
          { name: ExpLobbyFocusOnWelcomeAndReg.A, probability: 50 },
          { name: ExpLobbyFocusOnWelcomeAndReg.B, probability: 50 },
        ],
        authorized: false,
      },
      undefined,
      undefined,
      cmsABTests
    ) === ExpLobbyFocusOnWelcomeAndReg.B
  );
};
